<template>
	<div class="page-logo">
		<router-link to="/">
			<img v-if="logo" :key="logo.id" :title="logo.title" :src="home + logo.url" />
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'page-logo',
	props: {
		dark: {
			type: Boolean,
			default: true,
		},
		small: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		logo() {
			const WPVUE = window.WPVUE
			const { main_logo, main_logo_reversed, small } = WPVUE.options
			if (this.small) return small
			if (this.dark) return main_logo
			if (!this.dark) return main_logo_reversed
			return ''
		},
		home() {
			const WPVUE = window.WPVUE
			return WPVUE.home
		},
	},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.page-logo {
	a {
		display: inline-block;
	}
}
</style>
